export default "__VITE_ASSET__yKV85iSs__"